export default function toDateShort(Authentication, dateFilter) {
  'ngInject';

  return function link(date) {
    const format = Authentication.user.settings.usTimeFormat ? 'MMM dd' : 'dd MMM';
    return dateFilter(date, format);
  };
}
